import React from "react";
import { Route } from "react-router-dom";
import loadable from "@loadable/component";
import { PageLoader } from "GlobalComponent/PageLoader";
import { page } from "GlobalEnum/Page";
import { isQueryParamsValid } from "../utils/Global";
import { FINANCE_ENDPOINT, USED_FINANCE_PAGE_ROUTE } from "../constants/Global";
import { Pages } from "GlobalEnum/NewPage";

const FinanceLanding = loadable(
  () =>
    import(
      /* webpackChunkName: "financelanding-desktop" */ "../containers/FinanceLandingRoot.desktop"
    ),
  {
    fallback: <PageLoader />,
  }
);

export const FinanceAppLoadableDesktop = loadable(
  () =>
    import(
      /* webpackChunkName: "financeapp-desktop" */ "../containers/FinanceApp.js"
    ),
  {
    ssr: false,
    fallback: <PageLoader />,
  }
);

export const FinanceRouteDesktop = (
  <Route
    exact
    path={FINANCE_ENDPOINT}
    render={props => {
      return isQueryParamsValid(props.location.search) ? (
        <FinanceAppLoadableDesktop
          {...props}
          pageId={page.FINANCE_LANDING_PAGE_DESKTOP.id}
          newPageId={Pages.FINANCE_LANDING_PAGE.id}
        />
      ) : (
        <FinanceLanding
          {...props}
          pageId={page.FINANCE_LANDING_PAGE_DESKTOP.id}
          newPageId={Pages.FINANCE_LANDING_PAGE.id}
        />
      );
    }}
  />
);

export const UsedCarFinanceRouteDesktop = [
  <Route
    exact
    path={USED_FINANCE_PAGE_ROUTE}
    key="used-car-finance"
    render={props => {
      return (
        <FinanceAppLoadableDesktop
          {...props}
          isUsedCarCustomer
          pageId={page.FINANCE_LANDING_PAGE_DESKTOP.id}
          newPageId={Pages.FINANCE_LANDING_PAGE.id}
        />
      );
    }}
  />,
];
